import { render, staticRenderFns } from "./RelatorioComponent.vue?vue&type=template&id=f79388ba"
import script from "./RelatorioComponent.vue?vue&type=script&lang=js"
export * from "./RelatorioComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports